import { OrgAddressDto } from '../../../types/swaggerTypes'
import React, { Fragment, FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { ClinTheme } from '../../../ClinTheme'
import { Col, Row } from 'react-grid-system'
import { ClinText } from '../../../components/ClinText'
import { ClinButton } from '../../../components/ClinButton'

interface IAccountDetailsAddressBlockProps {
  address: OrgAddressDto
  isAdmin: boolean
  onRemove: (address: OrgAddressDto) => void
}

export const AccountDetailsAddressBlock: FunctionComponent<
  IAccountDetailsAddressBlockProps
> = ({ address, isAdmin, onRemove }) => {
  const { t } = useTranslation()

  return (
    <>
      <Fragment key={`ship-to-${address.addressId}`}>
        <Row
          justify="center"
          align="center"
          style={{ gap: `${ClinTheme.space[2]}px 0` }}
        >
          <Col xs={12} md={10}>
            <ClinText
              color={ClinTheme.colors.darkGrey}
              fontWeight={ClinTheme.fontWeights.medium}
            >
              {t('account_details:address')}
            </ClinText>
            <ClinText fontWeight={ClinTheme.fontWeights.medium}>
              {[
                address?.address1,
                address?.address2,
                address?.address3,
                address?.address4,
                address?.state,
                address?.country,
                address?.postalCode
              ]
                .filter(Boolean)
                .join(', ')}
            </ClinText>
          </Col>
          <Col xs={2} style={{ right: '10px', textAlign: 'right' }}>
            {isAdmin && (
              <ClinButton
                variant="linkButton"
                fontSize={ClinTheme.fontSizes[2]}
                onClick={() => onRemove(address)}
              >
                {t('common:buttons.delete')}
              </ClinButton>
            )}
          </Col>
        </Row>
      </Fragment>
    </>
  )
}
